<template>
  <div>
    <Navbar />
    <div class="container">
      <transition name="fade">
        <div v-if="!packOrderList.length" class="text-center">
          <div class="spinner-border text-primary" style="width: 3rem; height: 3rem;" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </transition>

      <transition name="fade">
        <div class="row" v-if="packOrderList.length">
          <div class="col-md-8">
            <div class="d-flex justify-content-between">
              <h2>Pacotes ({{ packOrderList.length }})</h2>
              <div class="form-group">
                <input
                  v-model="filter"
                  type="text"
                  class="form-control"
                  placeholder="Pesquisar..."
                  @input="filterPacks"
                />
              </div>
            </div>

            <div>
              <div v-for="(pack, id) in packs" v-bind:key="id">
                <div v-show="!pack.hiddenInSearch" class="card">
                  <div class="card-body">
                    <img :src="pack.iconURL" width="64" class="pull-right" v-if="pack.iconURL" />
                    <h5 class="card-title">{{ pack.title["pt-br"] }}</h5>
                    <h6 class="card-subtitle mb-2 text-muted">{{ pack.productId }}</h6>
                    <div class="card-text">
                      <p>{{ pack.description["pt-br"] }}</p>

                      <span>Palavras: {{ pack.numberOfWords }}</span>
                      <br />
                      <span>Prévia: {{ getPackPreviewText(pack.previewText["pt-br"]) }}</span>
                      <br />

                      <span v-if="pack.price > 0">Preço: {{ pack.price }}</span>
                      <span v-else>
                        Preço:
                        <span class="badge badge-success">Grátis</span>
                      </span>
                      <br />

                      <span v-for="(value, key) in pack.info" v-bind:key="key" class="pack-badges">
                        <span v-if="value" class="badge badge-success">
                          {{ infoNamesHumanized[key] }}
                        </span>
                      </span>
                    </div>
                    <router-link :to="'add-pack/' + pack.productId" class="btn btn-primary">
                      Editar
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4">
            <h2>Ordem no app</h2>

            <draggable
              :list="packOrderList"
              :disabled="!orderListEnabled"
              class="list-group"
              ghost-class="ghost"
              :move="checkMove"
              @start="dragging = true"
              @end="dragging = false"
            >
              <div
                class="list-group-item"
                v-for="element in packOrderList"
                :key="element.productId"
              >
                {{ element.title["pt-br"] }}
              </div>
            </draggable>

            <button type="button" class="btn btn-primary w-100 mt-2" @click="savePackOrder()">
              Aplicar
            </button>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import { db } from "../main.js";
import Navbar from "../components/Navbar";
import draggable from "vuedraggable";
import Swal from "sweetalert2";
import { packsRef } from "../main";

export default {
  name: "Packs",

  components: {
    Navbar,
    draggable
  },

  created() {
    this.getPacks();
  },

  data() {
    return {
      packs: {},
      infoNamesHumanized: {
        isNewPack: "Novo",
        isFeature: "Recurso",
        isOffer: "Oferta"
      },
      packOrderList: [],
      orderListEnabled: true,
      dragging: false,
      filter: '',
    };
  },

  methods: {
    getPacks() {
      db.collection("playStoreProducts")
        .orderBy("order", "asc")
        .get()
        .then(querySnapshot => {
          querySnapshot.forEach(doc => {
            const packId = doc.id;
            const pack = doc.data();
            pack.iconURL = null;
            this.packs[packId] = pack;
            this.packOrderList.push(pack);
            this.downloadPackIcon(packId);
          });
        });
    },
    getPackPreviewText(words) {
      return words.join(" / ");
    },
    checkMove: function(e) {
      window.console.log("Future index: " + e.draggedContext.futureIndex);
      console.log(this.packOrderList);
    },
    savePackOrder() {
      Swal.fire({
        title: "Tem certeza?",
        text: "A nova disposição dos pacotes será replicada imediatamente para o app.",
        icon: "warning",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        allowOutsideClick: () => !Swal.isLoading(),
        preConfirm: () => {
          const packUpdatePromises = [];

          this.packOrderList.forEach((pack, index) => {
            pack.order = index;
            const packPromise = db
              .collection("playStoreProducts")
              .doc(pack.productId)
              .update(pack);
            packUpdatePromises.push(packPromise);
          });

          return Promise.all(packUpdatePromises)
            .then(response => {
              return response;
            })
            .catch(error => {
              Swal.showValidationMessage("Erro ao atualizar pacotes");
            });
        }
      }).then(result => {
        console.log(result);
        if (result.value) {
          Swal.fire(
            "Tudo certo!",
            "Os pacotes foram atualizados e as mudanças já foram replicadas no app!",
            "success"
          );
        }
      });
    },
    downloadPackIcon(packId) {
      packsRef
        .child(`${packId}/cover.png`)
        .getDownloadURL()
        .then(url => {
          this.packs[packId].iconURL = url;
        })
        .catch(function(error) {
          console.log(`Error downloading icon for pack: ${packId}`);
          console.log(error);
        });
    },
    filterPacks() {
      Object.entries(this.packs).forEach(([packId, pack]) => {
        const matchesQuery = pack.title['pt-br'].toLowerCase().includes(this.filter.toLowerCase())
        pack.hiddenInSearch = !matchesQuery
      })
    }
  }
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active em versões anteriores a 2.1.8 */ {
  opacity: 0;
}

.spinner-grow {
  margin-top: 16px;
}

.card {
  margin-bottom: 16px;
}

.card-text {
  margin-bottom: 8px;
}

.pack-badges {
  margin-right: 8px;
}

.list-group-item {
  cursor: move;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}
</style>
